import type { GameSettings } from "../domain/types";

export const DEFAULT_SETTINGS: GameSettings = {
  masterVolume: 0.8,
  musicVolume: 0.45,
  effectsVolume: 0.75,
  reducedShake: false,
  reducedParticles: false,
  highContrast: false,
  uiScale: 1,
  pauseWhenHidden: true,
};

const finiteOr = (value: number | undefined, fallback: number): number =>
  typeof value === "number" && Number.isFinite(value) ? value : fallback;

export function normalizeSettings(value: Partial<GameSettings> | undefined): GameSettings {
  const merged = { ...DEFAULT_SETTINGS, ...value };
  return {
    ...merged,
    masterVolume: Math.min(
      1,
      Math.max(0, finiteOr(merged.masterVolume, DEFAULT_SETTINGS.masterVolume)),
    ),
    musicVolume: Math.min(
      1,
      Math.max(0, finiteOr(merged.musicVolume, DEFAULT_SETTINGS.musicVolume)),
    ),
    effectsVolume: Math.min(
      1,
      Math.max(0, finiteOr(merged.effectsVolume, DEFAULT_SETTINGS.effectsVolume)),
    ),
    uiScale: Math.min(1.25, Math.max(0.85, finiteOr(merged.uiScale, DEFAULT_SETTINGS.uiScale))),
  };
}

export function nextUiScale(current: number): number {
  const choices = [0.9, 1, 1.1, 1.25] as const;
  const index = choices.findIndex((choice) => Math.abs(choice - current) < 0.01);
  return choices[(index + 1) % choices.length] ?? 1;
}
